const API = {
  //Contract
  CONTRACT_MEETING: "/v1/contracts/{contractId}/meeting",
  SAVE_DOCUMENT_MULTI: "/v1/contracts/{contractId}/upload-file/{workflowId}",
  SEND_DOCUMENT: "/v1/contracts/{contractId}/documents/send/",
  CONTRACT_DOCUMENT: "/v1/contracts/{contractId}/documents/",
  SAVE_CONTRACT_DOCUMENT: "/v1/contracts/{contractId}/documents/{workflowId}/",
  CONTRACTOR_RESEND: "/v1/contracts/resend/contractor/{contractId}/",
  CONTRACT_TOKEN: "/v1/contracts/token/",
  CONTRACT: "/v1/contracts/{contractId}",
  CONTRACT_DOCUMENT_APPROVAL_REQUEST:
    "/v1/contracts/{contractId}/documents/{workflowId}/approval/request",
  CONTRACT_DOCUMENT_APPROVAL_SEND:
    "/v1/contracts/{contractId}/documents/{workflowId}/approval_send/",
  CONTRACT_DOCUMENT_SIGN: "/v1/contracts/{contractId}/documents/{workflowId}/sign/",
  CONTRACT_DOCUMENT_REMOVE: "/v1/contracts/{contractId}/documents/",
  CONTRACT_STATUS: "/v1/contracts/{contractId}/status/",
  CONTRACT_CHECKED_TERM: "/v1/contracts/checked-term/{contractId}",
  CONTRACT_SIGN_BUSINESS: "/v1/contracts/sign-business/{hash}/",
  CONTRACT_BUSINESS: "/v1/contracts/business-contract/{contractId}",
  CONTRACT_VIDEO_ROLES: "/v1/contracts/video/{hash}/roles",
  CONTRACT_VIDEO: "/v1/contracts/video/{hash}/",
  CONTRACT_VIDEO_TOKEN: "/v1/contracts/video/{hash}/token/",
  CONTRACT_VIDEO_TOKEN2: "/v1/contracts/video/{hash}/token2/",
  CONTRACT_SIGN: "/v1/contracts/sign/{hash}/",
  CONTRACT_DOCUMENT_APPROVAL: "/v1/contracts/{contractId}/documents/{workflowId}/approval/{flag}",
  CONTRACT_DOCUMENT_RECEIVED: "/v1/contracts/{contractId}/documents/{workflowId}/received/",
  CONTRACTOR_CONFIRM: "/v1/contracts/contractor-confirm/{contractId}",
  CONTRACT_DELETE_FILE: "/v1/contracts/delete-file",
  CONTRACT_ALL: "/v1/contracts/all",
  CONTRACT_DRAFT: "/v1/contracts/draft/{contractId}/",
  CONTRACT_DRAFT_DELETE: "/v1/contracts/draft",
  CONTRACT_DRAFT_COUNT: "/v1/contracts/count-draft",
  CONTRACT_INSURANCES: "/v1/contracts/insurances",
  CONTRACT_API_FLEX: "v1{url}",
  OWNER_CONTRACT_API_FLEX: "v1/owner/{url}",
  RESONA_STATUS: "/v1/koufuri/status/",
  RESONA_SENDMAIL: "/v1/koufuri/send-mail/{contractId}",
  CONTRACT_LEDGER_HISTORY: "/v1/contracts/ledger/memo-history/{contractId}",
  LEDGER_STATUS: "/v1/contracts/ledger-memo",
  GET_CONTRACTOR_PDF_TERM: "/v1/contracts/get-contractor-term-pdf/{contractId}",
  DISABLE_CONTRACT_DOCUMENT: "/v1/contracts/disable-document/{contractDocumentId}",
  ACKNOWLEDGE_DISABLED_DOCUMENTS: "/v1/contracts/{contractId}/disabled-docs/acknowledge",

  //activity
  ACTIVITY: "/v1/activities/",

  //tasks
  TASK: "/v1/tasks/",

  //summary
  SUMMARY: "/v1/summary/",
  SUMMARY_AGENT: "/v1/summary/agent",

  //form
  FORM_DEFAULT: "/v1/forms/default",
  FORM_USER_SELECT: "/v1/forms/user/{id}/select",
  FORM_NORMAL: "/v1/forms/normal/{id}",
  FORM_SAVE: "/v1/forms/save/{id}",
  FORM_USER: "/v1/forms/user/{id}",
  FORU_USER_INFO: "/v1/forms/user/info/{userId}",
  CHECK_LISENSE: "v1/forms/check-lisense",

  //maintenance
  MAINTENANCE_TIME: `/v1/maintenance/time`,

  //export
  EXPORT_CONTRACT_CSV: "/v1/export/csv-contract",

  //import
  IMPORT_CHECK_CONTRACT_CSV: "/v1/import/check-contract-csv",
  IMPORT_CONTRACT: "/v1/import/import-contract",

  //auth
  AUTH_SMS: "/v1/authentication/sms/{token}",
  AUTH_FORGOT_PASS_RESET: "/v1/authentication/forgot/password/reset/",
  AUTH_FORGOT_PASS: "/v1/authentication/forgot/password/{token}",
  AUTH_SIGNUP_COMPANY_PUT: "/v1/authentication/signup/company/{token}",
  AUTH_SIGNUP_COMPANY_POST: "/v1/authentication/signup/company/",
  AUTH_SIGNUP_CONFIRM: "/v1/authentication/signup/confirm/",
  AUTH_SIGNUP_COMPANY_CONFIRM: "/v1/authentication/signup/company/confirm/",
  AUTH_SIGNUP_LICENSE_CONFIRM: "/v1/authentication/signup/license/confirm/",
  AUTH_SIGNUP: "/v1/authentication/signup/",
  AUTH_SIGNIN: "/v1/authentication/signin{endpoint}",
  AUTH_OPTCODE: "/v1/authentication/otpcode/{code}",
  AUTH_CHECK_EMAIL: "/v2/contracts/check-owner-exists",

  //download
  DOWNLOAD: "/v1/download/{hash}/",
  DOWNLOAD_DOCUMENTS: "/v1/download/documents/",
  DOWNLOAD_DOCUMENTS_CONTRACTOR: "/v1/download/documents-contractor",
  DOWNLOAD_RECEIVE_FILE_CONFIRM_CONTRACTOR: "/v1/download/receive-file-confirm-contractor/{hash}",
  DOWNLOAD_RECEIVE_FILE_CONFIRM_BUSINESS: "/v1/download/receive-file-confirm-business/{hash}",

  //company
  COMPANY_APPROVAL_FLOW_LIST: "/v1/company/approval-flow/list",
  COMPANY_APPROVAL_FLOW: "/v1/company/approval-flow/",
  COMPANY_APPROVAL_FLOW_ID: "/v1/company/approval-flow/{id}",
  COMPANY_APPROVAL_FLOW_BRANCH: "/v1/company/approval-flow/branch/{id}",
  COMPANY_BRANCHES: "/v1/company/branches/",
  COMPANY_BRANCHES_HAVE_USER: "/v1/company/branches-have-user/{id}",
  COMPANY_ACCOUNTS: "/v1/company/accounts/",
  COMPANY_OTHER_ACCOUNTS: "/v1/company/other-accounts/",
  COMPANY_OTHER_ACCOUNT_BY_ID: "/v1/company/other-accounts/{id}",
  COMPANY_ACCOUNT_ID: "/v1/company/accounts/{id}",
  COMPANY_USER_FORM_USERS: "/v1/company/user-form/users",
  COMPANY_SEARCH_BY_NAME: "/v1/company/search-by-name",
  COMPANY_USER: "/v1/company/users/",
  COMPANY_SEARCH_COMPANY_BY_NAME: "/v1/company/search-company-by-name",
  COMPANY_BUSINESS_COMPANIES: "/v1/company/business-companies",
  COMPANY_WORKFLOWS: "/v1/company/workflows/",
  COMPANY_WORKFLOWS_ID: "/v1/company/workflows/{id}",
  COMPANY_GET_COMPANY_BY_MANAGER: "/v1/company/get-company-by-manager",
  COMPANY_CREATE: "/v1/company/create",
  COMPANY_UPDATE_ID: "/v1/company/update/{id}",
  COMPANY_DETAIL_COMPANY_AGENT: "/v1/company/detail-company-agent/{id}",
  COMPANY_UPDATE_BUSINESS: "/v1/company/update-business",
  COMPANY_UPDATE_OWNER_AGENCY: "/v1/company/update-owner-agency",
  COMPANY: "/v1/company/",
  COMPANY_ADD_OTHER_ACCOUNT: "v1/company/add-other-account",

  //mypage
  MYPAGE_PASSWORD: "/v1/mypage/password/",
  MYPAGE_UPDATE_BUSINESS: "/v1/mypage/update-business",
  MYPAGE: "/v1/mypage/",

  // config
  CONFIG: "/v1/config",
}

export default API
